import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { isPresent } from '@ember/utils';

export default class TagNewFormComponent extends Component {
  @tracked value = '';

  @action
  onBlur() {
    isPresent(this.value)
      ? this.args.onSubmit(this.value)
      : this.args.onDismiss();
  }
}
